var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPreAssessment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M192 0C150.2 0 114.6 26.7 101.5 64L64 64C28.7 64 0 92.7 0 128L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64l-37.5 0C269.4 26.7 233.8 0 192 0zM64 112l45.3 0c7.7 21.3 27.9 36 51.7 36s44-14.7 51.7-36L320 112c8.8 0 16 7.2 16 16l0 320c0 8.8-7.2 16-16 16L64 464c-8.8 0-16-7.2-16-16l0-320c0-8.8 7.2-16 16-16zm128-48a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM112 208c-8.8 0-16 7.2-16 16s7.2 16 16 16l16 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-16 0zm64 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l112 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-112 0zM112 304c-8.8 0-16 7.2-16 16s7.2 16 16 16l16 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-16 0zm64 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l112 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-112 0zM112 400c-8.8 0-16 7.2-16 16s7.2 16 16 16l16 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-16 0zm64 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l112 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-112 0z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreAssessment);
export default __webpack_public_path__ + "static/media/pre-assessment.dd2f5cbd44585c915496f3af1212f912.svg";
export { ForwardRef as ReactComponent };